import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-icon-status',
  templateUrl: './split-icon-status.component.html',
  styleUrls: ['./split-icon-status.component.scss']
})
export class SplitIconStatusComponent {
  @Input({required: true}) public status: string = '';
}
